export default "__VITE_ASSET__Mkj1JcQ2__"